import { categoryTags, overviewItems } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function OverviewSection() {
  return (
    <section id="overview" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-8">
        <SectionHeading
          kicker="图集速览"
          title="标题 + 一句短摘要，扫着看就够"
          desc="桌面端一屏能看六条，移动端也能一眼抓住重点；每条都对应一组高清原图。"
        />

        <div className="mb-8 flex flex-wrap gap-2">
          {categoryTags.map((tag) => (
            <a
              key={tag}
              href="#gallery"
              className="rounded-full border border-background-300 bg-background-100 px-4 py-1.5 text-xs font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:bg-primary-50 hover:text-primary-700"
            >
              {tag}
            </a>
          ))}
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {overviewItems.map((item) => (
            <a
              key={item.id}
              href="#download"
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 md:p-5"
            >
              <div className="mb-3 flex items-center justify-between">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                  <i className="ri-bookmark-3-line text-base" />
                </span>
                <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-900">
                  {item.tag}
                </span>
              </div>
              <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-600">
                {item.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}